import * as echarts from "echarts";

export function renderBarChart(el: HTMLElement, dados: Record<string, number>): echarts.ECharts {
  const chart = echarts.init(el);
  const categorias = Object.keys(dados);
  chart.setOption({
    tooltip: { trigger: "axis" },
    grid: { left: 40, right: 20, top: 20, bottom: 30 },
    xAxis: { type: "category", data: categorias },
    yAxis: { type: "value" },
    series: [{ type: "bar", data: categorias.map((c) => dados[c]) }],
  });
  return chart;
}
